/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
* ------------------------------------------------------------------------------------------------------------
* Klaviyo Forms
* 1. FOOTER NEWSLETTER 
* 2. NEWSLETTER SECTION
* 3. NEWSLETTER MODAL
* ------------------------------------------------------------------------------------------------------------
*/
(function() {
  var RsKlaviyoNewsletter = class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-action="init-klaviyo"]');
      this.msg = this.querySelector('[data-atom="rs-form-banner"]');
      this.onSubmit = this.onSubmit.bind(this);

      if (this.form) {
        this.klaviyoAttachToForms();
        this.form.addEventListener('submit', this.onSubmit);
      }
    }
    klaviyoAttachToForms() {
      var id = '#' + (this.form.id || '');
      if (this.form.id && KlaviyoSubscribe && KlaviyoSubscribe.attachToForms) {
        KlaviyoSubscribe.attachToForms(id, {
          hide_form_on_success: true,
          extra_properties: {
            $source: this.form.dataset.klaviyoSrc || ''
          }
        });
      }
    }
    onSubmit(e) {
      e.preventDefault();

      fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${this?.form?.a?.value}`, {
          method: 'POST',
          headers: {
            revision: '2024-02-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this?.form?.email?.value
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: this?.form?.g?.value
                  }
                }
              }
            }
          })
        }
      ).catch(function (error) {
        console.error('Error: ', error);
      });

      if (this.form) {
        this.form.style.display = 'none';
      }
      if (this.msg) {
        this.msg.classList.remove('hidden-phone', 'hidden-tablet-and-up');
      }
    }

  }
  window.customElements.define('rs-klaviyo-newsletter', RsKlaviyoNewsletter);
})();

/* ------------------------------------------------------------------------------------------------------------
* Klaviyo Added to Cart Tracking
* ------------------------------------------------------------------------------------------------------------
*/
(function() {
  document.addEventListener('variant:added', function(event) {
    const detail = event && event.detail ? event.detail : {};
    const src = detail.src;
    const cart = detail.cart;
    const cartVariant = detail.variant;
    let cartData = {};

    // Klaviyo created variables
    let addedItem = window.item;
    let klaviyo = window.klaviyo || [];

    // Update Klaviyo created item price. Klaviyo injected snippet uses product
    // price which may not be the actual price of the added varaint.
    if (addedItem && cartVariant) {
      addedItem.Price = window.RS.helpers.formatMoney(cartVariant.price);
    }

    // If not on the pdp or is the main product form on the pdp and the Klaviyo
    // item object does not exist, mimic Klaviyo item object as best as possible.
    // Some properties are not available from JS Shopify object.
    if (src !== 'pdp' || ( src === 'pdp' && !addedItem)) {
      if (cartVariant) {
        addedItem = {
          Brand: cartVariant.vendor,
          ImageURL: cartVariant.image,
          Name: cartVariant.product_title,
          Price: window.RS.helpers.formatMoney(cartVariant.price),
          ProductID: cartVariant.product_id,
          URL: `${window.themeVariables.routes.secureShopUrl}${cartVariant.url}`
        }
      }
    }

    if (addedItem) {
      addedItem.src = src;
    }

    if (cart) {
      // Format from Klaviyo docs:
      // https://help.klaviyo.com/hc/en-us/articles/115001396711-Guide-to-Creating-an-Added-to-Cart-Event-for-Shopify
      cartData = {
        total_price: cart.total_price/100,
        $value: cart.total_price/100,
        total_discount: cart.total_discount,
        original_total_price: cart.original_total_price/100,
        items: cart.items
      }
    }

    klaviyo.push([
      'track',
      'Added to Cart',
      {
        ...(addedItem || {}),
        ...cartData
      }
    ])
  });
})();

/* ------------------------------------------------------------------------------------------------------------
* Blog Search
* ------------------------------------------------------------------------------------------------------------
*/
(function() {
  var articleSearchAjax = function(input, blog) {
    $.ajax({
      url: `/search?view=article&type=article&q=*${input}*+AND+tag:search_${blog}`,
        dataType: 'json',
        type: 'get',        
        success: function (res) {
          // Clear article
          var articleList = document.querySelector("article-list");
          articleList.innerHTML = "";
          document.querySelector("page-pagination")?.remove();
          document.querySelector(".no-result")?.remove();
          
          res?.articles.forEach(function(article) {
            articleList.append(createArticleItem(article, blog));
          });

          var container = document.querySelector(".vertical-breather .container");
          if(Math.ceil(res.count / 48) > 1) { // Add read more button
            var readMore = document.createElement("button");
            readMore.setAttribute("page", 2);
            readMore.setAttribute("maxPage", res.count ? Math.ceil(res.count / 48) : 1);
            readMore.setAttribute("class", "read-more button button--primary");
            readMore.innerHTML = "Read More";
            readMore.addEventListener("click", function(event) { articleReadMore(event, input, articleList, blog) });
    
            container.append(readMore);
          } else if(res.count == 0) { // No result
            // Remove read more
            document.querySelector(".read-more")?.remove();

            var noResult = document.createElement("p");
            noResult.setAttribute("class", "no-result text--center");
            noResult.innerHTML = "No Results Found";
            container.append(noResult);
          }
        },
        error: function (XMLHttpRequest) {
          console.log("ERROR: ", XMLHttpRequest)
        } 
    });
  }

  var createArticleItem = function(article, blog) {
    var newArticle = document.createElement("div");
    newArticle.setAttribute("reveal", "");
    newArticle.setAttribute("class", "article-item image-zoom");
    newArticle.setAttribute("style", "opacity: 1;");

    var link1 = document.createElement("a");
    link1.setAttribute("href", article.url);
    link1.setAttribute("class", "article-item__image-container");

    var img = document.createElement("img");
    img.setAttribute("class", "article-item__image");
    img.setAttribute("sizes", "(max-width: 740px) 81vw, (max-width: 999px) 37vw, 425px");
    img.setAttribute("loading", "lazy");
    img.setAttribute("height", "733");
    img.setAttribute("width", "550");
    img.setAttribute("alt", article.image_alt);
    img.setAttribute("src", article.image);

    var textContainer = document.createElement("div");
    textContainer.setAttribute("class", "article-item__content text-container");

    var link2 = document.createElement("a");
    link2.setAttribute("href", `/blogs/${blog}/tagged/${article.tags[0]}`);
    link2.setAttribute("class", "article-item__category heading heading--xsmall");
    link2.innerHTML = article.tags[0];

    var h3 = document.createElement("h3");
    h3.setAttribute("class", "article-item__title heading h4");

    var link3 = document.createElement("a");
    link3.setAttribute("href", article.url);
    link3.append(article.title);

    var excerpt = document.createElement("div");
    excerpt.setAttribute("class", "article-item__excerpt text--small");
    excerpt.innerHTML = article.excerpt_or_content;

    link1.append(img);
    newArticle.append(link1);
    textContainer.append(link2);
    h3.append(link3);
    textContainer.append(h3);
    textContainer.append(excerpt);
    newArticle.append(textContainer);

    return newArticle;
  }

  var articleReadMore = function(e, input, articleList, blog) {
    var page = Number(e.target.getAttribute("page"));
    var maxPage = Number(e.target.getAttribute("maxpage"));
    if(page <= maxPage) {
      $.ajax({
        url: `/search?view=article&type=article&q=*${input}*+AND+tag:search_${blog}&page=${page}`,
          dataType: 'json',
          type: 'get',        
          success: function (res) {
            res?.articles.forEach(function(article) {
              articleList.append(createArticleItem(article, blog));
            });
    
            var readMore = document.querySelector(".read-more")
            if(page == maxPage) {
              readMore.remove(); // Remove read more
            } else {
              readMore.setAttribute("page", page++);
            }
          },
          error: function (XMLHttpRequest) {
            console.log("ERROR: ", XMLHttpRequest)
          } 
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    var articleSearch = document.getElementById("article-search");
    if(articleSearch) {
      articleSearch.addEventListener("submit", function(e) {
        e.preventDefault();
        var path = window.location.pathname.split('/');
        var blog  = path[2]; // Blog part should only be in index 2
        var input = $(e.target).find("input[type=text]")[0].value;
        if(input) {
          articleSearchAjax(input, blog);
        } else {
          location.reload();
        }
      });
    }
  });
})();

/* ------------------------------------------------------------------------------------------------------------
* Generic reveal on scroll handler
* ------------------------------------------------------------------------------------------------------------
*/
(function() {
  const initRevealOnScroll = () => {
    const revealOnScrollElems = document.querySelectorAll('[data-reveal-on-scroll]:not([data-reveal-on-scroll=""]');
    const REVEAL_CLASS = 'reveal-fade-up';
    let counter = revealOnScrollElems.length;
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const revealClass = entry.target.dataset.revealOnScroll || REVEAL_CLASS;
          if (!entry.target.classList.contains(revealClass)) {
            entry.target.classList.add(revealClass);
            observer.unobserve(entry.target);
            counter--;
    
            if (!counter) {
              observer.disconnect();
            }
          }
        }
      })
    }
    const revealObserver = new IntersectionObserver(callback);
  
    revealOnScrollElems.forEach((elem) => {
      revealObserver.observe(elem);
    });

    return revealObserver;
  };
  const disconnectObserver = (observer) => {
    if (observer && observer.disconnect) {
      observer.disconnect();
    }
  };
  const onShopifySectionEvent = (observer) => {
    disconnectObserver(observer);
    mainObserver = initRevealOnScroll();
  };
  let mainObserver = {};

  document.addEventListener('DOMContentLoaded', () => {
    mainObserver = initRevealOnScroll();
  });
  document.addEventListener('shopify:section:unload', () => {
    onShopifySectionEvent(mainObserver);
  });
  document.addEventListener('shopify:section:load', () => {
    onShopifySectionEvent(mainObserver);
  });
})();